const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ;

class ApiClient {
  async request(endpoint, options = {}) {
    const url = `${API_BASE_URL}${endpoint}`;
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'ngrok-skip-browser-warning': 'true',
        ...options.headers,
      },
      ...options,
    };

    try {
      const response = await fetch(url, config);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('API request failed:', error);
      throw error;
    }
  }

  // Logo APIs
  async uploadLogo(file) {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await fetch(`${API_BASE_URL}/logo/upload`, {
      method: 'POST',
      headers: {
        'ngrok-skip-browser-warning': 'true',
      },
      body: formData,
    });
    return await response.json();
  }

  async getCurrentLogo() {
    const data = await this.request('/logo/current');
    if (data.exists) {
      return {
        ...data,
        logo_url: `${API_BASE_URL}/logo/image`
      };
    }
    return data;
  }

  // Document APIs
  async uploadDocuments(files, metadata = {}) {
    const formData = new FormData();
    files.forEach(file => formData.append('files', file));
    
    if (Object.keys(metadata).length > 0) {
      formData.append('metadata', JSON.stringify(metadata));
    }
    
    const response = await fetch(`${API_BASE_URL}/documents/upload`, {
      method: 'POST',
      headers: {
        'ngrok-skip-browser-warning': 'true',
      },
      body: formData,
    });
    return await response.json();
  }

  async getDocuments() {
    return this.request('/documents/all');
  }

  async getKnowledgeDocuments() {
    return this.request('/documents/knowledge');
  }

  async getKnowledgeStats() {
    return this.request('/documents/knowledge/stats');
  }

  async deleteDocument(docId) {
    return this.request(`/documents/${docId}`, { method: 'DELETE' });
  }

  async processDocument(docId) {
    return this.request(`/documents/process/${docId}`, { method: 'POST' });
  }

  async getDocumentStatus(docId) {
    return this.request(`/documents/status/${docId}`);
  }

  // Settings APIs
  async getChatSettings() {
    return this.request('/settings/chat');
  }

  async updateChatSettings(settings) {
    return this.request('/settings/chat', {
      method: 'POST',
      body: JSON.stringify(settings),
    });
  }

  // Widget APIs
  async getWidgetConfig() {
    return this.request('/widget/config');
  }

  async updateWidgetConfig(config) {
    return this.request('/widget/config', {
      method: 'POST',
      body: JSON.stringify(config),
    });
  }

  async getEmbedCode() {
    return this.request('/widget/embed-code');
  }

  // Logs APIs
  async getSystemLogs(level = null, limit = 100) {
    const params = new URLSearchParams();
    if (level) params.append('level', level);
    params.append('limit', limit);
    
    return this.request(`/logs/system?${params}`);
  }

  async exportSystemLogs(level = null) {
    const params = new URLSearchParams();
    if (level) params.append('level', level);
    
    const response = await fetch(`${API_BASE_URL}/logs/system/export?${params}`, {
      headers: {
        'ngrok-skip-browser-warning': 'true',
      },
    });
    return response.blob();
  }

  // Chat APIs
  async sendChatMessage(message, sessionId = 'default') {
    const url = `${API_BASE_URL}/chat/message`;
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'text/event-stream',
        'Cache-Control': 'no-cache',
        'ngrok-skip-browser-warning': 'true',
      },
      body: JSON.stringify({
        message: message,
        session_id: sessionId,
        stream: true
      }),
    };
    return fetch(url, config);
  }

  async getChatHealth() {
    return this.request('/chat/health');
  }

  // API Tools APIs
  async getApiTools() {
    return this.request('/tools/');
  }

  async createApiTool(tool) {
    return this.request('/tools/', {
      method: 'POST',
      body: JSON.stringify(tool),
    });
  }

  async updateApiTool(toolId, tool) {
    return this.request(`/tools/${toolId}`, {
      method: 'PUT',
      body: JSON.stringify(tool),
    });
  }

  async toggleApiTool(toolId) {
    return this.request(`/tools/${toolId}/toggle`, {
      method: 'POST',
    });
  }

  async deleteApiTool(toolId) {
    return this.request(`/tools/${toolId}`, {
      method: 'DELETE',
    });
  }


}

const apiClient = new ApiClient();
export default apiClient;